/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import EmberObject, { computed, set } from '@ember/object';

import FilterConstants from '../../../../../filter-constants';

export default class extends EmberObject {
  stageQ;
  gain;
  init() {
    super.init();
    set(this, 'q0', this.stageQ);
    set(this, 'h', this.gain);
    this.k = 0;
    this.r3Value = 0;
    this.r4Value = FilterConstants.Limits.INFINITY;
  }

  @computed('h', 'q0') get b() {
    return this.h / 2 / (this.q0 * this.q0);
  }
}
